/*
 *
 * Date: 2025
 * Description: List management page
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { Box, Typography , CircularProgress , Paper } from "@mui/material"
import { useEffect , useState , useContext, ReactElement } from "react";
import { Link, useNavigate } from "react-router-dom";

//Constants & functions
import { default_list } from "../utils/constant";
import { handleFetch } from "../api/fetch";
import { delay } from "../utils/utility";

//Interfaces
import { i_initial_props } from "../interfaces/utility.interface";
import { i_list } from "../interfaces/items.interface";
import { i_user_list_form } from "../interfaces/display.interfaces";

//Components
import Footer from "../components/utils/footer";
import ListCard from "../components/card/list.card";
import FitModal from "../components/modal/fit.modal";
import ListUserForm from "../components/form/list.user.form";

//Context && hooks
import { useAlert } from "../context/alert.context";
import { MainContext } from "../context/context";
import { t_display } from "../types/types";



const Lists = ( props : i_initial_props ) : ReactElement => {
    const { HandleLogout , user } = useContext(MainContext)
    const [ display , setDisplay ] = useState<'view' | 'form' | 'submit'>('view')
    const [ data , setData ] = useState<i_list[]>([])
    const [ userForm , setUserForm ] = useState<i_list>(default_list)
    const [ userErrors , setUserErrors ] = useState<i_list>(default_list)
    const [ loading , setLoading ] = useState<boolean>(false)
    const [ pathing ] = useState<string>(props.uploadPath + props.path + '/uploads/parts/')

    //Hooks
    const { showTopAlert } = useAlert();
    const nav = useNavigate()
    useEffect(()=> {
        const getLists = async() => {
            setLoading(true)
            const res = await handleFetch('/list' , 'GET' , true , null)
            if(res.type === 'Success'){
                if(res.data.items.length === 0){
                    nav('/catalog')
                }
                setData( user.type === 'admin' ? res.data : [res.data])
                if(user.type === 'user')
                setUserForm({ ...userForm, ...res.data})
            }
            if(res.type === 'Unauthorized'){
                HandleLogout(nav)
            }
            setLoading(false)
        }
        getLists()
    },[])

    const handleSubmit = async( ) : Promise<void> => {
        setLoading(true)
        await delay(1000)
        const res = await handleFetch('/list/order', 'POST' , true , userForm)
        if(res.type === 'Success'){
            setUserForm(default_list)
            setDisplay('submit')
            showTopAlert(res)
        } else{
            if(res.type === 'Unauthorized'){
                HandleLogout(nav)
                return
            }
            showTopAlert(res)
        }
        setLoading(false)
    }

    const ListUserFormProps : i_user_list_form = { 
        form : userForm,
        errors : userErrors,
        loading : loading,
        setForm : setUserForm,
        setErrors : setUserErrors,
        callback : handleSubmit,
    }
    return (
        <Box >
            <Box sx={{position: 'sticky', top: 0, height: '100%', overflowY: 'auto'}}>
                <>
                {loading === true ?
                    <Box sx={{ display : 'flex' , justifyContent : 'center' , marginTop : '40vh'}}>
                        <CircularProgress size={100}/>
                    </Box> 
                    :
                    <Box>
                        {display === 'view' &&
                            <Box>
                                <Box sx={{ padding : '25px'}}>
                                    <Typography variant="h4" sx={{ textAlign : 'center'}}>{ user.type === 'admin' ?  "Lists management" : "Your cart"}</Typography>
                                </Box>
                                {data.map((list : i_list , i : number ) => 
                                    <Box key={i}>
                                        <ListCard list={list} path={pathing} />
                                    </Box>
                                )}
                                <Box sx={{ marginBottom : '2vh'}}>
                                    {data[0]?.items?.length > 0 && (
                                        <ListUserForm {...ListUserFormProps} />
                                    )}
                                </Box>
                            </Box>
                        }
                        {display === 'submit' && 
                            <Paper elevation={4} sx={{ maxWidth : '600px' , marginLeft : 'auto' , marginRight : 'auto' , padding : 4, marginTop : '10vh'}}>
                                <Typography variant="h4" sx={{ textAlign : 'center'}}>Order submitted successfully!</Typography>
                                <Typography variant="h5" sx={{ textAlign : 'center'}}>We will reach you for the next steps..</Typography>
                                <Box sx={{ display : 'flex' , justifyContent : 'center' , marginTop : '2vh'}}>
                                    <Box component={Link} sx={{ padding :1 , fontSize : 20}} to={'/catalog'}>Go back to the catalog</Box>
                                </Box>
                            </Paper>
                        }
                    </Box>
                }</>
            </Box>
        </Box>
    )
}

export default Lists;